import React, { useEffect, useState } from 'react';
import * as S from './styles';
import { motion } from 'framer-motion'

//hooks
import { useChangeIcon } from '../../utils/hooks';

//components
//import { StickyContainer, Sticky } from 'react-sticky';

//icons
import SatyaTech from '../../icons/SatyaTech2.png';
import SatyaTechM from '../../icons/SatyaTech2.png';

function MenuBar({ className, initialPose, selected, setIndex, onClick, mainIcon, activeIndex = 0 }) {
  
  //custom hooks
  const isuseChangeIcon = useChangeIcon();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);
  const isAndroid = /Android/i.test(navigator.userAgent || '');

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const tabs = [
    { label: 'Home', index: 0 },
    { label: 'Services', index: 1 },
    { label: 'Work', index: 2 },
    { label: 'Client', index: 3 },
    { label: 'Contact', index: 4 }
  ];

  const handleTabClick = index => {
    setIndex(index);
    if (isMobile) setMenuOpen(false);
  };

  return (
    <S.MenuBar 
      className={className} 
      as={motion.div}
      variants={{
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: -30 }
      }}
      initial="hidden"
      animate="visible"
      >
      <S.Header>
        {isuseChangeIcon ? (
          <img src={SatyaTechM} alt="logo" style={{ height: "100%", maxHeight: "46px", width: "auto" }} onClick={() => setIndex(0)} role="button" tabIndex={0} onKeyDown={e => (e.key === "Enter" || e.key === " ") && setIndex(0)} />
        ) : (
          <img src={SatyaTech} alt="logo" style={{ height: "100%", maxHeight: "52px", width: "auto" }} onClick={() => setIndex(0)} role="button" tabIndex={0} onKeyDown={e => (e.key === "Enter" || e.key === " ") && setIndex(0)} />
        )}
      </S.Header>
      <S.Icons $isMobile={isMobile} $menuOpen={menuOpen}>
        {isMobile && (
          <S.HamburgerButton
            type="button"
            aria-label="Toggle navigation menu"
            aria-expanded={menuOpen}
            $isAndroid={isAndroid}
            onClick={() => setMenuOpen(v => !v)}
          >
            <S.HamburgerIcon $isAndroid={isAndroid} />
          </S.HamburgerButton>
        )}

        <S.Item $isMobile={isMobile} $menuOpen={menuOpen}>
          {tabs.map(tab => (
            <S.Link
              key={tab.index}
              type="button"
              role="tab"
              aria-selected={activeIndex === tab.index}
              tabIndex={activeIndex === tab.index ? 0 : -1}
              active={activeIndex === tab.index}
              onClick={() => handleTabClick(tab.index)}
            >
              {tab.label}
            </S.Link>
          ))}
        </S.Item>
      </S.Icons>
    </S.MenuBar>
  );
}

export default MenuBar;
